import { css } from 'styled-components';
import is from 'styled-is';

import { withStyles } from 'utils/style';
import { Z_INDEX } from 'modules/journey/stop-status-log/z-index';

const warningStyles = () =>
  css`
    background-color: var(--error100);
    color: var(--error900);
  `;

const possibleWarningStyles = () =>
  css`
    background-color: var(--accent100);
    color: var(--accent900);
  `;

export default withStyles`
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 2px solid var(--grey100);
  border-left: 2px solid var(--grey100);
  color: var(--grey700);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${(props) => (props.debugWarningOnTop ? Z_INDEX.ON_TOP : Z_INDEX.WARNING)};
  transition: transform .3s ease-in-out;

  ${is('over', 'clickable')`
    transform: translateY(-50%);
  `}

  ${is('opened')`
    transform: translateY(-100%);
  `}

  ${is('possibleWarning')`
    ${possibleWarningStyles}
  `}

  ${is('warning')`
    ${warningStyles}
  `}
`;
